import { Spinner, Message } from '../../index';
import { InputText } from '../../../utils/dynamicForm';
import AddItemsToGroup from './AddItemsToGroup';

export const FormMasterGroups = ({
                                     /* basic props */
                                     edit,
                                     formCleanHandler,
                                     isLoading,
                                     isError,
                                     isErrorUpdate,
                                     isLoadingUpdate,
                                     isLoadingPost,
                                     register,
                                     errors,
                                     handleSubmit,
                                     submitHandler,
                                     error,
                                     /* new props */
                                     dataUsers,
                                     dataMachines,
                                     selectedUsers,
                                     setSelectedUsers,
                                     selectedMachines,
                                     setSelectedMachines,
                                     setValue
                                 }) => (
    <div
        className="modal fade"
        id="masterGroupModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="masterGroupModalLabel"
        aria-hidden="true"
    >
        <div className="modal-dialog">
            <div className="modal-content modal-background">
                <div className="modal-header">
                    <h3 className="modal-title" id="masterGroupModalLabel">
                        {edit ? 'Edit Group' : 'Add a NEW Group'}
                    </h3>
                    <button
                        id="masterGroupModalClose"
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={formCleanHandler}
                    />
                </div>

                <div className="modal-body">
                    {isLoading ? (
                        <Spinner />
                    ) : isError || isErrorUpdate ? (
                        <Message variant="danger">{error?.message || 'Error'}</Message>
                    ) : (
                        <form onSubmit={handleSubmit(submitHandler)}>
                            {InputText({
                                register,
                                errors,
                                label: 'Group Name',
                                name: 'group_name',
                                placeholder: 'e.g. North Region',
                                isRequired: true
                            })}

                            {InputText({
                                register,
                                errors,
                                label: 'Description',
                                name: 'description',
                                placeholder: '',
                                isRequired: false
                            })}

                            {/* USERS */}
                            <AddItemsToGroup
                                label="Users"
                                name="users"
                                options={dataUsers?.data || []}
                                selected={selectedUsers}
                                setSelected={setSelectedUsers}
                                setValue={setValue}
                                errors={errors}
                            />

                            {/* MACHINES */}
                            <AddItemsToGroup
                                label="Machines"
                                name="machines"
                                options={dataMachines?.data || []}
                                selected={selectedMachines}
                                setSelected={setSelectedMachines}
                                setValue={setValue}
                                errors={errors}
                            />

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                    onClick={formCleanHandler}
                                >
                                    Close
                                </button>

                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={isLoadingPost || isLoadingUpdate}
                                >
                                    {isLoadingPost || isLoadingUpdate ? (
                                        <span className="spinner-border spinner-border-sm" />
                                    ) : (
                                        'Save'
                                    )}
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    </div>
);

export default FormMasterGroups;
